import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { APIValidationError, get, post, put, remove } from '../services/crud'
import { IContactDTO, IContactInput } from './typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}/Contact`

//========== C R E A T E ==========
export const createContact = createAsyncThunk<
  IContactDTO,
  IContactInput,
  { rejectValue: APIValidationError }
>('contact/create', async (contact, thunkApi) => {
  const response = await post(`${baseUrl}`, contact)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

//========== R E M O V E ==========
export const deleteContact = createAsyncThunk<
  number,
  number,
  { rejectValue: string }
>('contact/delete', async (id, thunkApi) => {
  const response = await remove(`${baseUrl}/${id}`)
  if (response.ok) return id
  return thunkApi.rejectWithValue(await response.json())
})

//========== U P D A T E ==========
export const updateContact = createAsyncThunk<
  IContactDTO,
  IContactInput,
  { rejectValue: APIValidationError }
>('contact/update', async (contact, thunkApi) => {
  const response = await put(`${baseUrl}`, contact)

  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

//========== G E T   L O C A T I O N   C O N T A C T S ==========
export const getLocationContacts = createAsyncThunk<
  IContactDTO[],
  string,
  { rejectValue: APIValidationError }
>('contact/update', async (locationId, thunkApi) => {
  const response = await get(`${baseUrl}/core/location/${locationId}`)

  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})
